import { CartState } from './cart.types'

export const initialState: Omit<CartState, keyof CartStateActions> = {
  cart: null,
  optimisticCart: null,
  productsNotAvailable: [],
  productsNotAvailableInStock: [],
  productsNotAvailableForDeliveryMethod: [],
  productsQuantityExceeded: false,
  isLoading: false,
  isProcessing: false,
  cartReplacementsPayload: [],
  productsInProcess: [],
  activeSpecialPromotions: [],
  pendingOperations: {},
}

export interface CartStateActions {
  flushPendingOperations: CartState['flushPendingOperations']
  hasPendingOperations: CartState['hasPendingOperations']
  cleanup: CartState['cleanup']
  init: CartState['init']
  setCart: CartState['setCart']
  setIsLoading: CartState['setIsLoading']
  updateOptimisticCart: CartState['updateOptimisticCart']
  reconcileCart: CartState['reconcileCart']
  trackOperation: CartState['trackOperation']
  addProductToProcess: CartState['addProductToProcess']
  removeProductFromProcess: CartState['removeProductFromProcess']
  getProductCount: CartState['getProductCount']
  getRestProductsCount: CartState['getRestProductsCount']
  getAllCartItemsLength: CartState['getAllCartItemsLength']
  getCartItem: CartState['getCartItem']
  getCartItemCount: CartState['getCartItemCount']
  getItemByProductId: CartState['getItemByProductId']
  getCartById: CartState['getCartById']
  createCart: CartState['createCart']
  mergeCarts: CartState['mergeCarts']
  refreshCart: CartState['refreshCart']
  queueCartOperation: CartState['queueCartOperation']
  addToCart: CartState['addToCart']
  removeFromCart: CartState['removeFromCart']
  clearCart: CartState['clearCart']
  setProductReplacements: CartState['setProductReplacements']
  getProductReplacements: CartState['getProductReplacements']
  replaceProduct: CartState['replaceProduct']
  addSlotToCart: CartState['addSlotToCart']
  TMSReserveSlotToCart: CartState['TMSReserveSlotToCart']
  extendSlot: CartState['extendSlot']
  addAddressToCart: CartState['addAddressToCart']
  detachDeliveryOrInvoiceAddressFromCart: CartState['detachDeliveryOrInvoiceAddressFromCart']
  cancelTmsReservation: CartState['cancelTmsReservation']
  addDiscountCodeToCart: CartState['addDiscountCodeToCart']
  removeDiscountCodeFromCart: CartState['removeDiscountCodeFromCart']
  setPackingOption: CartState['setPackingOption']
}
